module.exports = __webpack_public_path__ + "static/media/Public Affairs Consultants Logo.a908893b.png";